import { render, staticRenderFns } from "./NoteBlock.vue?vue&type=template&id=c2e806d2"
import script from "./NoteBlock.vue?vue&type=script&lang=js"
export * from "./NoteBlock.vue?vue&type=script&lang=js"
import style0 from "./NoteBlock.vue?vue&type=style&index=0&id=c2e806d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports